module.exports = __webpack_public_path__ + "static/media/DOKI-ETH.c8ec851d.png";